<template>
  <ModalBase :title="t('general__text__settings') + ' (Admin)'">
    <template #content>
      <CheckBoxStandard
        v-for="action in allActions"
        :key="action.actionName"
        :checked="privileges.allowedActions.includes(action.actionName)"
        :title="`Action ${action.actionName}`"
        @value-changed="(value) => handleCheck(action.actionName, value)"
      />
      <CheckBoxStandard
        :checked="privileges.allowHidden"
        title="Show Hidden"
        @value-changed="(value) => handleCheckHidden(value)"
      />
      <CheckBoxStandard
        :checked="privileges.isAdmin"
        title="Is Admin"
        @value-changed="(value) => setAdmin(value)"
      />
    </template>
  </ModalBase>
</template>

<script setup lang="ts">
import CheckBoxStandard from '@/design-system/atoms/CheckBoxStandard.vue'
import ModalBase from './ModalBase.vue'
import { useI18n } from 'vue-i18n'
import { usePrivileges } from './privileges'
import { allActions } from './actionStore'

const { t } = useI18n()

const privileges = usePrivileges()

const handleCheck = (action: string, value: Event) => {
  const checked = (value.target as HTMLInputElement).checked
  if (checked) {
    privileges.setAllowedActions(
      [...privileges.allowedActions.filter((a) => a !== action), action].filter(Boolean)
    )
  } else {
    const newActions = privileges.allowedActions.filter((a) => a !== action)
    privileges.setAllowedActions(newActions)
  }
}

const setAdmin = (value: Event) => {
  const checked = (value.target as HTMLInputElement).checked
  if (checked) {
    privileges.setAdmin()
  } else {
    privileges.unsetAdmin()
  }
}

const handleCheckHidden = (value: Event) => {
  const checked = (value.target as HTMLInputElement).checked
  if (checked) {
    privileges.showHidden()
  } else {
    privileges.hideHidden()
  }
}
</script>
